import { useContext } from "react"
import { HeaderContext } from "~/context/HeaderContext"

export default function useHeaderHeightSpace(): number {
  const context = useContext(HeaderContext)

  return context.headerHeight / 8
}
